// Ant Design theme tokens, matching the existing YDS brand color (#d43e01).
const antdTheme = {
  token: {
    colorPrimary: "#d43e01",
    colorLink: "#d43e01",
    colorInfo: "#d43e01",
    borderRadius: 6,
    fontFamily:
      "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    Menu: {
      itemSelectedBg: "#fdece4",
      itemSelectedColor: "#d43e01",
    },
    Button: {
      colorPrimaryHover: "#b93601",
      colorPrimaryActive: "#a13001",
    },
  },
};

export default antdTheme;
